import { connect } from 'react-redux';

import Calendar from '../../components/calendar';

import {
    applyFilters,
    setCalendarActive,
    setCalendarView,
    setFocusDate,
    toggleFilter,
    toggleCalendarFilters,
    fetchCalendarThunk,
    setEventWindowStart,
    setEventWindowEnd,
    setFocusDateDirect,
    resetCalEvents,
    resetCalendarBtn,
    onLoadCalendarLocations
} from '../../actions';
import {
    getActiveEvents,
    getShowCalendar,
    getShowCalendarToggle,
    getCalLoading
} from '../../reducers';

const mapStateToProps = state => ({
    userInfo: state.data.userInfo,
    events: getActiveEvents(state),
    eventWindowStart: state.calendar.eventWindowStart,
    eventWindowEnd: state.calendar.eventWindowEnd,
    view: state.calendar.view,
    focus: state.calendar.focus,
    filters: state.calendar.filters,
    calendar: getShowCalendar(state),
    calendarToggle: getShowCalendarToggle(state),
    calendarFiltersActive: state.calendar.calendarFiltersActive,
    getCalLoading: getCalLoading(state)
});

const mapDispatchToProps = dispatch => ({
    onLoadCalendarLocations: model => dispatch(onLoadCalendarLocations(model)),
    applyFilters: filters => dispatch(applyFilters(filters)),
    setCalendarActive: active => dispatch(setCalendarActive(active)),
    setCalendarView: view => dispatch(setCalendarView(view)),
    setFocusDate: (direction, increment) =>
        dispatch(setFocusDate(direction, increment)),
    toggleFilter: value => dispatch(toggleFilter(value)),
    toggleCalendarFilters: () => dispatch(toggleCalendarFilters()),
    fetchCalendarThunk: paramObj => dispatch(fetchCalendarThunk(paramObj)),
    setEventWindowStart: value => dispatch(setEventWindowStart(value)),
    setEventWindowEnd: value => dispatch(setEventWindowEnd(value)),
    setFocusDateDirect: payload => dispatch(setFocusDateDirect(payload)),
    resetCalEvents: () => dispatch(resetCalEvents()),
    resetCalendarBtn: () => dispatch(resetCalendarBtn())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Calendar);



// WEBPACK FOOTER //
// ./src/containers/calendar/index.js